module.exports = __webpack_public_path__ + "bd55b417.png";